<section class="main">
    <h1 *ngIf="!status_edit">Add Section</h1>
    <h1 *ngIf="status_edit">Edit Section</h1>
    <hr>
    <div>
        <form [formGroup]="addForm">
            <div>
                <label>Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
            <div class="mt-3">
                <label>Start</label>
                <input formControlName="start" type="number" class="form-control">
            </div>
            <div class="mt-3">
                <label>End</label>
                <input formControlName="end" type="number" class="form-control">
            </div>
            <div class="mt-3">
                <label>Price</label>
                <input formControlName="price" type="number" class="form-control">
            </div>

            <button *ngIf="!status_edit" class="mt-3 btn" (click)="addSection()">
                Add Section
            </button>
            <button *ngIf="status_edit" class="mt-3 btn" (click)="editSection()">
                Edit Section
            </button>
        </form>
    </div>
</section>